<template>
    <div class="content1">
        <!-- <headLine></headLine> -->
        <div class="static-title">
            <div class="tit-static">
                <img src="../assets/img/shebei.png" alt="" />
                <div>电话呼出量统计</div>
            </div>
            <!--			<div class="tit-static">-->
            <!--				<div>-->
            <!--					<el-date-picker size="medium" v-model="dataTime" type="daterange" range-separator="至" start-placeholder="开始日期"-->
            <!--					 end-placeholder="结束日期" @change="startTime" format="yyyy-MM-dd HH:mm:ss"-->
            <!--                            value-format="yyyy-MM-dd HH:mm:ss">-->
            <!--					</el-date-picker>-->
            <!--				</div>-->
            <!--				<div @click="exhale" style="cursor:pointer;">更多<i class="el-icon-arrow-right"></i></div>-->
            <!--			</div>-->
        </div>

        <div class="sta-center">
            <div>
                <div class="echarts-title">呼出电话统计</div>
                <div>
                    <DateLine :dataTime="dataTime"></DateLine>
                </div>
            </div>
            <!--			<div>-->
            <!--				<div class="echarts-title">接通率统计</div>-->
            <!--				<div>-->
            <!--					<DateLine1 :dataTime="dataTime"></DateLine1>-->
            <!--				</div>-->
            <!--			</div>-->
        </div>

        <div class="static-title">
            <div class="tit-static">
                <img src="../assets/img/shebei.png" alt="" />
                <div>电话呼入量统计</div>
            </div>
            <!--			<div class="tit-static">-->
            <!--				<div>-->
            <!--					<el-date-picker size="medium" v-model="dataTime1" type="daterange" range-separator="至" start-placeholder="开始日期"-->
            <!--					 end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">-->
            <!--					</el-date-picker>-->
            <!--				</div>-->
            <!--				<div @click="callIn" style="cursor:pointer;">更多<i class="el-icon-arrow-right"></i></div>-->
            <!--			</div>-->
        </div>

        <div class="sta-center">
            <div>
                <div class="echarts-title">呼入电话统计</div>
                <div>
                    <DateLines :dataTime1="dataTime1"></DateLines>
                </div>
            </div>
            <!--			<div>-->
            <!--				<div class="echarts-title">接通率统计</div>-->
            <!--				<div>-->
            <!--					<DateLine2 :dataTime1="dataTime1"></DateLine2>-->
            <!--				</div>-->
            <!--			</div>-->
        </div>

        <!--		<div class="static-bottom">-->
        <!--			<div style="width: 46%;display: flex;justify-content: space-between;">-->
        <!--				<div class="tit-static">-->
        <!--					<img src="../assets/img/shebei.png" alt="">-->
        <!--					<div>进线分时段统计</div>-->
        <!--				</div>-->
        <!--				<div>-->
        <!--					<div class="tit-static">-->
        <!--						<div>-->
        <!--							<el-date-picker size="medium" v-model="dataTime2" type="date" value-format="yyyy-MM-dd HH:mm:ss">-->
        <!--							</el-date-picker>-->
        <!--						</div>-->
        <!--						<div @click="timeInterval" style="cursor:pointer;">更多<i class="el-icon-arrow-right"></i></div>-->
        <!--					</div>-->
        <!--				</div>-->
        <!--			</div>-->
        <!--			<div style="width: 46%;display: flex;justify-content: space-between;">-->
        <!--				<div class="tit-static">-->
        <!--					<img src="../assets/img/shebei.png" alt="">-->
        <!--					<div>进线分时段统计</div>-->
        <!--				</div>-->
        <!--				<div>-->
        <!--					<div class="tit-static">-->
        <!--						<div>-->
        <!--							<el-date-picker size="medium" v-model="dataTime3" type="date" value-format="yyyy-MM-dd HH:mm:ss">-->
        <!--							</el-date-picker>-->
        <!--						</div>-->
        <!--						<div style="cursor:pointer;">更多<i class="el-icon-arrow-right"></i></div>-->
        <!--					</div>-->
        <!--				</div>-->
        <!--			</div>-->
        <!--		</div>-->

        <!--		<div class="sta-bottom">-->
        <!--			<div>-->
        <!--				<TimeInfo :dataTime2="dataTime2"></TimeInfo>-->
        <!--			</div>-->
        <!--			<div>-->
        <!--				<TimeInfos :dataTime3="dataTime3"></TimeInfos>-->
        <!--			</div>-->
        <!--		</div>-->
        <div style="height: 30px; width: 100%; background-color: #f2f2f2"></div>
    </div>
</template>

<script>
import DateLine from "./graph/line.vue"
import DateLines from "./graph/lines.vue"
import DateLine1 from "./graph/line1.vue"
import DateLine2 from "./graph/line2.vue"
import TimeInfo from "./graph/timeInfo.vue"
import TimeInfos from "./graph/timeInfos.vue"
import headLine from "../components/headline"
export default {
    components: {
        DateLine,
        headLine,
        DateLines,
        DateLine1,
        TimeInfo,
        DateLine2,
        TimeInfos,
    },
    data() {
        return {
            value1: "",
            dataTime: [],
            dataTime1: [],
            dataTime2: "",
            dataTime3: "",
        }
    },
    methods: {
        exhale() {
            this.$router.push({
                name: "exhaleCount",
            })
        },
        callIn() {
            this.$router.push({
                name: "callInCount",
            })
        },
        timeInterval() {
            this.$router.push({
                name: "jinxian",
            })
        },
        startTime(val) {
            console.log(val)
            // this.formdata.startTime = val[0]
            // this.formdata.endtTime = val[1]
            // this.$emit('dataTime', val)
            // this.dataTime = val
        },
    },
}
</script>

<style lang="less" scoped>
.content1 {
    width: 100%;
    // height: 100%;
    background-color: #f2f2f2;
}

.static-title {
    width: 96%;
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
}

.tit-static {
    display: flex;
    align-items: center;
}

.tit-static > div:last-child {
    margin-left: 20px;
}

.sta-center {
    width: 100%;
    background-color: #ffffff;
    height: 500px;
    //margin: 0 auto;
    //display: flex;
    //justify-content: space-between;
}

//.sta-center>div:first-child {
//	width: 100%;
//	background-color: #FFFFFF;
//}
//
//.sta-center>div:nth-child(2) {
//	width: 45%;
//	background-color: #FFFFFF;
//}

.echarts-title {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
}

.static-bottom {
    width: 96%;
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
}

.static-bottom > div {
    width: 48%;
}

.sta-bottom {
    width: 98%;
    height: 500px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.sta-bottom > div {
    width: 49%;
    background-color: #ffffff;
}
</style>
